import script from "./edit_product.vue?vue&type=script&setup=true&lang=js"
export * from "./edit_product.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__